/**
 * Configuration settings for file uploads.
 */
export const fileUploadConfig = {
    /**
     * Maximum file size to allow to be uploaded
     */
    maximumFileSize: (1024 * 1024 * 12), // 12mb.
};
